export function getKeyByUniqueFields({ id, entityName }: { id: number; entityName: string }) {
  return `${entityName}_${id}`;
}
